export default __webpack_public_path__ + "static/media/logo_MetaMask.3910d6ad.svg";